import React, { Component, ErrorInfo, ReactNode } from 'react';
import { logger } from '@/lib/logger';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

const DefaultSubscriptionFallback = () => (
  <div className="min-h-screen bg-background flex items-center justify-center p-4">
    <div className="max-w-md w-full bg-card border border-border rounded-lg p-6 text-center">
      <h2 className="text-xl font-semibold mb-2">Mode d'accès limité</h2>
      <p className="text-muted-foreground mb-4">
        Une erreur est survenue lors de la vérification de votre abonnement. 
        Vous pouvez continuer à naviguer avec un accès limité.
      </p>
      <button 
        onClick={() => window.location.reload()}
        className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
      >
        Réessayer
      </button>
    </div>
  </div>
);

export class SubscriptionErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    logger.error('SubscriptionErrorBoundary: Subscription error detected', { message: error.message });
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error('SubscriptionErrorBoundary caught error', { 
      error: error.message, 
      componentStack: errorInfo.componentStack 
    });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <DefaultSubscriptionFallback />;
    }

    return this.props.children;
  }
}
